<template>
  <v-container>
    <v-row class="d-flex justify-center ga-10">
      <v-col class="d-flex justify-center pt-12" cols="8">
        <h1 class="text-center">FORGOT PASSWORD</h1>
      </v-col>
      <v-col cols="12">
        <p class="pb-7">
          Please provide us your e-mail address to reset your password.
        </p>
        <v-form v-model="valid">
          <v-text-field
            variant="outlined"
            v-model="email"
            label="Enter your email"
            :rules="[rules.required, rules.email]"
            required
          ></v-text-field>
        </v-form>
      </v-col>
      <v-col class="d-flex justify-center">
        <v-btn
          size="x-large"
          block
          color="primary"
          @click="resetPassword"
          :disabled="!valid"
        >
          SEND REQUEST
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { auth } from "@/firebaseConfig.js";
import { sendPasswordResetEmail } from "firebase/auth";

export default {
  data() {
    return {
      email: "",
      valid: false,
      rules: {
        required: (v) => !!v || "Email is required",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      },
    };
  },
  methods: {
    resetPassword() {
      // Use the initialized `auth` directly
      sendPasswordResetEmail(auth, this.email).then(() => {
        this.$router.push({ name: "SignIn" });
      });
    },
  },
};
</script>
